import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { StatusCode, type Customer, REACT_QUERY_KEYS } from '@hungryroot/rest';
import { getCustomerSelf } from '@hungryroot/rest/api/v2/customers/self/get';

type OptionType = Omit<
  UseQueryOptions<
    Customer,
    unknown,
    Customer,
    (
      | number
      | 'self'
      | Record<string, string | number | boolean | string[]>
      | REACT_QUERY_KEYS
      | undefined
    )[]
  >,
  'queryFn' | 'queryKey'
>;

/**
 * @deprecated use useIdentify from @hungryroot/customer instead
 */
export function useCustomerSelf(options: OptionType = {}) {
  return useQuery({
    queryKey: [REACT_QUERY_KEYS.CUSTOMERS],
    queryFn: async () => {
      const resp = await getCustomerSelf();

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp, null, 2));
      }

      return resp.data;
    },
    ...options,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    retryOnMount: false,
    staleTime: 5 * 60 * 1000,
    retry: 0,
  });
}
